function pushDataLayer (event, payload) {
  window.dataLayer = window.dataLayer || []
  dataLayer.push({ ecommerce: null })
  dataLayer.push({
    event: event,
    ecommerce: payload
  })
}

function productDataFromJsonApi (product) {
  const productData = {}
  const product_type = product.field_payment_type_default
  const product_bundle = product.type.replace('commerce_product--', '')
  let item_category = product.field_category === 'adoption' ? 'Adopcja' : 'Darowizna'

  if (product_bundle === 'adoption_kids' && item_category === 'Adopcja') {
    item_category = 'Adopcja dla dzieci'
  }

  const item_name = product.title
  let item_id
  let price

  if (product_type === 'monthly') {
    item_id = product.field_sf_action_reg
    price = product.field_price_recurring_merged[0].number
  } else if (product_type === 'single') {
    item_id = product.field_sf_action_once
    price = product.field_price_merged[0].number
  }

  if (item_id) productData.item_id = item_id
  if (item_name) productData.item_name = item_name
  productData.item_brand = 'WWF'
  if (item_category) productData.item_category = item_category
  if (price) productData.price = Number(price)
  productData.quantity = 1

  return productData
}

export { pushDataLayer, productDataFromJsonApi }
